import { MarketValue } from "app/marketValue/interfaces";
import { formatDateOrTime } from "app/formatting/functions";

export function getHeadInfoItems(inMarketValue?: MarketValue): string[] {
    const result = ["Aktuelles Chart"];

    if (inMarketValue) {
        if (inMarketValue.lastDate) {
            result.push(formatDateOrTime(inMarketValue.lastDate));
        }

        if (inMarketValue.exchange) {
            result.push(inMarketValue.exchange);
        }
    }

    return result;
}
